import React from 'react';
import { Breadcrumb, notification, Modal } from 'antd/lib';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../../common/LoadingGrommet';

import TablaExpedientes from '../TablaExpedientes';
import FormBuscar from './FormBuscar';
import _ from 'lodash';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsBuscarExpedientes from '../../../../actions/busquedaExpedientes';
import * as actionsMain from '../../../../actions/main';

import getExpedientes from '../../../../graphql/querys/contravenciones/getExpedientes.graphql';
import getExpedientesDelContraventor from '../../../../graphql/querys/contravenciones/getExpedientesDelContraventor.graphql';
import deleteExpediente from '../../../../graphql/mutations/contravenciones/deleteExpediente.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const confirm = Modal.confirm;

@compose(
  graphql(deleteExpediente, {
    name: 'deleteExpediente',
    options: {
      refetchQueries: [{ query: getExpedientes }],
    },
  })
)
class BuscarExpedientesContraventor extends React.Component {
  state = {
    persona: {},
    step: 0,
    guardado: false,
    loading: false,
    expediente: {},
    listaFiltrada: null,
    filtroTipoDoc: null,
    filtroNumDoc: null,
    filtroNombre: null,
    filtroApellido: null,
    filtroEstado: null,
    pagina: 1,
    cantidadTotal: 0,
    cantidadPorPagina: 10,
    consultaRealizada: false,
  };

  onDelete = id => {
    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar esta autorizacion?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteExpediente({
            variables: {
              _id: id,
            },
          })
          .then(respuesta => {
            console.log('La respuesta que recibi fue...');
            console.log(respuesta);

            if (respuesta) {
              notification.warning({
                message: 'Expediente eliminado',
                description: 'El expediente fue eliminado correctamente',
              });
            }
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar el expediente');
            console.log(err);
            errorService(err, {
              _id: id,
            });
            Modal.error({
              title: 'Error en la eliminacion del expediente',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  onSubmit = values => {
    this.props.actionsBuscarExpedientes.setFiltrosBusqueda({
      ...values,
      pagina: 1,
      cantidadPorPagina: 10,
    });
    this.setState(
      {
        tipo_doc: values.tipo_doc,
        num_doc: values.num_doc,
        nombre: values.nombre,
        apellido: values.apellido,
        estado: values.estado,
        loading: true,
      },
      () => {
        this.lanzarconsulta();
      }
    );
  };

  lanzarconsulta = () => {
    // console.log('VOY A LANZAR LA CONSULTA!!!:');
    this.props.client
      .query({
        query: getExpedientesDelContraventor,
        variables: {
          tipo_doc: this.props.busquedaExpedientes.tipo_doc,
          num_doc: this.props.busquedaExpedientes.num_doc,
          nombre: this.props.busquedaExpedientes.nombre,
          apellido: this.props.busquedaExpedientes.apellido,
          estado: this.props.busquedaExpedientes.estado,
          pagina: this.props.busquedaExpedientes.pagina,
          cantidadPorPagina: this.props.busquedaExpedientes.cantidadPorPagina,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        if (res.data.getExpedientesDelContraventor) {
          // console.log('REPSUESTA: ');
          // console.log(res);
          this.setState(
            {
              consultaRealizada: true,
              listaFiltrada: res.data.getExpedientesDelContraventor.expedientes,
              cantidadTotal: res.data.getExpedientesDelContraventor.total,
              loading: false,
            },
            () => {
              this.ordenarLista(
                this.props.busquedaExpedientes.pagina,
                this.props.busquedaExpedientes.cantidadPorPagina
              );
            }
          );
        }
      })
      .catch(err => {
        console.log('TENGO UN ERROR: ', err);
        this.setState({
          loading: false,
        });
        notification.error({
          message:
            'Error a la hora de obtener los expedientes del contraventor buscado',
        });
      });
  };

  cambiarPagina = pagina => {
    this.props.actionsBuscarExpedientes.setFiltrosBusqueda({
      pagina: pagina,
    });
    this.setState(
      {
        pagina: pagina,
        loading: true,
      },
      () => {
        this.lanzarconsulta();
      }
    );
  };

  onVolver = () => {
    this.setState({
      consultaRealizada: false,
    });
  };

  cambiarTamañoPagina = tamaño => {
    this.props.actionsBuscarExpedientes.setFiltrosBusqueda({
      cantidadPorPagina: tamaño,
    });
    this.setState(
      {
        cantidadPorPagina: tamaño,
        loading: true,
      },
      () => {
        this.lanzarconsulta();
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaFiltrada,
      [
        expediente => {
          return expediente.numero;
        },
      ],
      ['desc']
    );

    this.setState({
      ...this.state,
      lista: listaOrdenada,
    });
  };

  render() {
    let listaExpedientes =
      (this.state.listaFiltrada && this.state.listaFiltrada.length > 0) ||
      this.props.busquedaExpedientes.tipo_doc ||
      this.props.busquedaExpedientes.num_doc ||
      this.props.busquedaExpedientes.nombre ||
      this.props.busquedaExpedientes.apellido ||
      this.props.busquedaExpedientes.estado
        ? this.state.lista
        : [];

    if (!listaExpedientes) {
      listaExpedientes = [];
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Expedientes</Breadcrumb.Item>
          <Breadcrumb.Item>Buscar</Breadcrumb.Item>
        </Breadcrumb>
        <div>
          <FormBuscar
            tipo_doc={this.props.busquedaExpedientes.tipo_doc}
            num_doc={this.props.busquedaExpedientes.num_doc}
            nombre={this.props.busquedaExpedientes.nombre}
            apellido={this.props.busquedaExpedientes.apellido}
            estado={this.props.busquedaExpedientes.estado}
            loading={this.state.loading}
            onSubmit={this.onSubmit}
          />
          <Loading isLoading={this.state.loading}>
            <TablaExpedientes
              expedientes={listaExpedientes}
              history={this.props.history}
              onDelete={this.onDelete}
              pagina={this.props.busquedaExpedientes.pagina}
              tamPagina={this.props.busquedaExpedientes.cantidadPorPagina}
              cambiarPagina={this.cambiarPagina}
              cambiarTamañoPagina={this.cambiarTamañoPagina}
              total={this.state.cantidadTotal}
              // onVolver={this.onVolver}
            />
          </Loading>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsBuscarExpedientes: bindActionCreators(
    actionsBuscarExpedientes,
    dispatch
  ),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(BuscarExpedientesContraventor));
